module.exports = __webpack_public_path__ + "img/social-links.0ddb8e9a.svg";